import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  Collapse,
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import TasksApproval from "../../src/assests/images/task_approval.svg";
import TasksApprovalactive from "../../src/assests/images/taskapproval_active.svg";
import Task from "../../src/assests/images/tasks.svg";
import Taskactive from "../../src/assests/images/Taskactive.svg";
import reports from "../../src/assests/images/reports.svg";
import reportsactive from "../../src/assests/images/reportsactive.svg";
import dashbord from "../../src/assests/images/dashboard.svg";
import dashbordactive from "../../src/assests/images/dashboardactive.svg";
import brands from "../../src/assests/images/brands.svg";
import brandsactive from "../../src/assests/images/brandactive.svg";
import retailer from "../../src/assests/images/retailer.svg";
import { decodeJWT, getToken } from "../utils/utils";
import arrowgrey from "../../src/assests/images/arrow-down-grey.svg";
import arrowred from "../../src/assests/images/arrow-down-curve-red.svg";
import people from "../../src/assests/images/people.svg";
import peopleactive from "../../src/assests/images/peopleactive.svg";


const drawerWidth = 275;

type SideNavProps = {
  open: boolean;
  onClose: () => void;
  isMobile: boolean;
  checked: boolean; setChecked: (val: boolean) => void
};

const MenuItems = [
  {
    id: 1,
    name: "Task",
    path: ["/manage-task", "/a"],
    icon: Task,
    activeIcon: Taskactive,
    roles: ["Admin", "Team Member", "Module Owner"],
  },
  {
    id: 2,
    name: "Cohorts",
    path: ["/cohorts-view"],
    icon: Task,
    activeIcon: Taskactive,
    roles: ["Admin", "Team Member", "Module Owner"],
  },
  {
    id: 3,
    name: "Tasks Approval",
    path: "/tasks-approval",
    icon: TasksApproval,
    activeIcon: TasksApprovalactive,
    roles: ["Admin", "Team Member", "Module Owner"],
  },
  //   {
  //     id: 2,
  //     name: "Task",
  //     path: ["/manage-task", "/assign-task"],
  //     icon: Task,
  //     activeIcon: Taskactive,
  //  roles: ["Admin", "Team Member","Module Owner"],
  //   },
  {
    id: 4,
    name: "Reports",
    icon: reports,
    activeIcon: reportsactive,
    roles: ["Admin", "Team Member", "Module Owner"],
    subMenu: [
      // { name: "Task Reports", path: "/reports/taskreports" },

      // { name: "Retailer Reports", path: "/reports/retailersreports" },
      // {name: "Rewards and Points book",path: "/reports/rewards-pointsreports",},

      { name: "Reports", path: "/reports/reportstable" },

      //{ name: "Taskss", path: "/reports/tasks" },
      { name: "Bulk Upload", path: "/reports/bulkupload" },

    ],

  },
  {
    id: 5,
    name: "Dashboard",
    path: "/",
    icon: dashbord,
    activeIcon: dashbordactive,
    roles: ["Admin", "Team Member", "Module Owner"],
  },
  {
    id: 6,
    name: "Brands",
    path: ["/brands", "/add-brand", "/edit-brand"],
    icon: brands,
    activeIcon: brandsactive,
    roles: ["Admin", "Team Member", "Module Owner"],
  },
  //   {
  //     id: 6,
  //     name: "Retailers",
  //     icon: retailer,
  //     activeIcon: TasksApprovalactive,
  //  roles: ["Admin", "Team Member","Module Owner"],
  //     subMenu: [
  //       { name: "Retailers List", path: "/retailers/retailerslist" },
  //       { name: "Leader Board", path: "/retailers/leaderboard" },
  //     ],
  //   },
  {
    id: 7,
    name: "Team Members",
    path: ["/team-Members", "/team-form"],
    icon: people,
    activeIcon: peopleactive,
    roles: ["Admin", "Team Member", "Module Owner"],
  },

];

const SideNav: React.FC<SideNavProps> = ({ open, onClose, isMobile, checked }) => {
  const token = getToken();
  const decodedToken = decodeJWT(token);
  console.log(decodedToken, "decodedTokendecodedTokendecodedToken", token, "tokentokentokentoken")
  const userRole = decodedToken?.user_role_name || "guest";
  console.log(userRole, "userRolepppppppp")
  const acessdata = decodedToken?.access
  console.log(acessdata, "acessdatasssssssssssss")
  const accessData = decodedToken?.access || [];
  console.log(accessData, "accessDataaccessData")
  const moduleNames: string[] = decodedToken?.moduleNamess || [];
  const roleNames: string[] = decodedToken?.roleNames || [];
  console.log(moduleNames, "moduleNamesmoduleNamesmoduleNames", roleNames, "roleNamesroleNamesroleNames", checked, "checkedcheckedcheckedchecked")

  let filteredMenuItems = [];
  console.log(userRole, "kloo000000000", accessData, "accessDataaccessDataaccessData")
  if (userRole === "Team Member" || userRole === "Module Owner") {
    let normalizedAccess = accessData.map((a: string) => a.toLowerCase());

    // Add "team member" manually (in lowercase to match)
    // if (!normalizedAccess.includes("Team Members")) {
    //   normalizedAccess.push("Team Members");
    // }
    let finalAccess: string[] = [];

    if (userRole === "Module Owner") {
      finalAccess = [...normalizedAccess, 'team members'];
      console.log(finalAccess, "finalAccessfinalAccessfinalAccess");
    } else {
      finalAccess = normalizedAccess;
    }

    filteredMenuItems = MenuItems.filter((menu) =>
      finalAccess.includes(menu.name.toLowerCase())
    );
    console.log(filteredMenuItems, "2599888887888")
  } else {

    filteredMenuItems = MenuItems;
  }

  console.log(filteredMenuItems, "sssssssssssssssssssss")

  const location = useLocation();
  const [openSubMenu, setOpenSubMenu] = useState<number | null>(null);

  const handleSubMenuToggle = (id: number) => {
    setOpenSubMenu((prev) => (prev === id ? null : id));
  };
  if (checked === false && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
    moduleNames.push("Team Members");
    console.log("checked is false and roleNames includes Admin and Module Owner");
    console.log(moduleNames, "oooooooooooooo", MenuItems.map((menu) => menu.name.toLowerCase()), "llllllllll")
    const normalizedModuleNames = moduleNames.map(name => name.toLowerCase());

    filteredMenuItems = MenuItems.filter((menu) =>
      normalizedModuleNames.includes(menu.name.toLowerCase())
    );


  } else if (checked === true) {
    filteredMenuItems = MenuItems;
  }
  console.log(filteredMenuItems, "filteredMenuItemsfilteredMenuItems", checked)
  return (
    <Drawer
      variant={isMobile ? "temporary" : "persistent"}
      open={open}
      onClose={isMobile ? onClose : undefined}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          marginTop: isMobile ? "55px" : "80px",
          // borderTop:"1px solid rgba(231, 232, 233, 1)"//
        },
      }}
      ModalProps={{
        keepMounted: true,
      }}
      className="sidenav"
    >
      <List sx={{ paddingTop: "24px" }}>
        {filteredMenuItems.map((menu) => {
          const isActiveSubMenu =
            menu.subMenu?.some((sub) =>
              location.pathname.startsWith(sub.path)
            ) || false;

          const isActive =
            Array.isArray(menu.path)
              ? menu.path.some((path) => location.pathname.startsWith(path))
              : location.pathname === menu.path || isActiveSubMenu;

          return (
            <React.Fragment key={menu.id}>
              <ListItemButton
                onClick={() => menu.subMenu && handleSubMenuToggle(menu.id)}
                component={menu.subMenu ? "div" : Link}
                to={
                  menu.subMenu
                    ? undefined
                    : Array.isArray(menu.path)
                      ? menu.path[0]
                      : menu.path
                }
                sx={{
                  ".MuiButtonBase-root .MuiSvgIcon-root": {
                    fontSize: "18px", // Custom icon size or font size for SvgIcon
                    color: isActive ? "blue" : "gray", // You can add custom color here
                  },
                  "&:hover": {
                    background: isActive ? "#FFEBEF" : "transparent",
                  },
                  background: isActive
                    ? "#FFEBEF"
                    : "transparent",
                  margin: isActive
                    ? "0 20px 12px 20px"
                    : "0 20px 14px 20px",
                  borderRadius: "8px",
                  color: isActive ? "black" : "inherit",
                }}
              >
                <Box
                  sx={{
                    color: isActive ? "black" : "inherit",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    width: "100%",

                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: isActive ? "#fff" : "inherit",
                      minWidth: "unset !important",
                    }}
                  >
                    <img
                      src={isActive ? menu.activeIcon : menu.icon}
                      alt={`${menu.name} icon`}
                      width="24"
                      height="24"
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={menu.name}
                    sx={{
                      color: isActive
                        ? "rgba(185, 0, 34, 1)"
                        : "rgba(73, 74, 75, 1)",
                      ".MuiTypography-root": { fontWeight: isActive ? "600 !important" : "500 !important" }
                    }}
                  />
                </Box>
                {menu.subMenu && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img
                      src={isActiveSubMenu ? arrowred : arrowgrey}
                      alt="dropdown icon"
                      width="16"
                      height="16"
                      style={{ transition: 'transform 0.3s ease-in-out', }}
                    />
                  </Box>
                )}
              </ListItemButton>
              {menu.subMenu && (
                <Collapse
                  in={openSubMenu === menu.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {menu.subMenu.map((sub) => (
                      <ListItemButton
                        key={sub.path}
                        component={Link}
                        to={sub.path}
                        sx={{
                          "&:hover": { backgroundColor: "transparent" },
                          padding: "0 10px 28px 55px !important",
                          margin: "0 1px",
                          borderRadius: "8px",
                          ".MuiTouchRipple-root": { display: "none" },

                        }}
                      >

                        <ListItemText
                          primary={sub.name}
                          sx={{
                            color:
                              location.pathname === sub.path
                                ? "rgba(185, 0, 34, 1)"
                                : "rgba(73, 74, 75, 1)",
                            // ".MuiTypography-root":{fontWeight: isActive ? "600 !important": "500 !important"}
                          }}
                        />
                      </ListItemButton>
                    ))}
                  </List >
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
      </List>
    </Drawer>
  );
};

export default SideNav;
